import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    listPanel: {
      backgroundColor: '#FFFFFF',
      width: '400px',
      maxHeight: '400px',
      paddingRight: '20px',
    },
    notification: {
      paddingTop: '5px',

      '& .MuiAvatar-root': {
        backgroundColor: '#CACAFC99',
        color: '#3C419A',
        width: '60px',
        height: '60px',
        marginRight: '18px',
      },
      '& .MuiListItemText-primary': {
        fontSize: '14px',
        fontWeight: 400,
      },
      '& .MuiListItemText-secondary': {
        color: '#3560FF',
        marginTop: '5px',
      },
    },
    notRead: {
      fontWeight: 900,
    },
    title: {
      fontWeight: 600,
      fontSize: '18px',
      margin: '18px 18px 0 18px',
    },
  }),
);
